module.exports = __webpack_public_path__ + "fonts/Inter-100-vietnamese26.5fc7f74.woff2";